var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 84,
    viewBox: "0 0 64 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 64C34.1217 64 36.1566 63.1571 37.6569 61.6569C39.1571 60.1566 40 58.1217 40 56C40 51.56 36.4 48 32 48C29.8783 48 27.8434 48.8429 26.3431 50.3431C24.8429 51.8434 24 53.8783 24 56C24 58.1217 24.8429 60.1566 26.3431 61.6569C27.8434 63.1571 29.8783 64 32 64ZM56 28C58.1217 28 60.1566 28.8429 61.6569 30.3431C63.1571 31.8434 64 33.8783 64 36V76C64 78.1217 63.1571 80.1566 61.6569 81.6569C60.1566 83.1571 58.1217 84 56 84H8C5.87827 84 3.84344 83.1571 2.34315 81.6569C0.842854 80.1566 0 78.1217 0 76V36C0 31.56 3.6 28 8 28H12V20C12 14.6957 14.1071 9.60859 17.8579 5.85786C21.6086 2.10714 26.6957 0 32 0C34.6264 0 37.2272 0.517315 39.6537 1.52241C42.0802 2.5275 44.285 4.00069 46.1421 5.85786C47.9993 7.71504 49.4725 9.91982 50.4776 12.3463C51.4827 14.7728 52 17.3736 52 20V28H56ZM32 8C28.8174 8 25.7652 9.26428 23.5147 11.5147C21.2643 13.7652 20 16.8174 20 20V28H44V20C44 16.8174 42.7357 13.7652 40.4853 11.5147C38.2348 9.26428 35.1826 8 32 8Z",
    fill: "#FFC107"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.f28b0e5a.svg";
export { ForwardRef as ReactComponent };